/**
 * Service: couponsApi
 */
angular.module('acme.common.service.couponsApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('CouponsApiService', [ '$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/coupons';
        this.categories.service = endpoint + '/coupon/categories';
        this.effectiveDates.service = endpoint + '/coupon/dates';
        this.templates.service = endpoint + '/coupon/category/event/schedule/relations/event/templates';
        return this;
      },

      list: function(props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: [
                'pageSize',
                'page',
                'sortField',
                'sortDirection',
                'search',
                'startDate',
                'endDate'
              ]
            }
          });

          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + q
        });
      },

      detail: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            code: props.code,
            name: props.name,
            description: props.description,
            programName: props.programName,
            companyName: props.companyName,
            resellerId: props.resellerId,
            categoryId: props.categoryId
          }
        });
      },

      update: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: {
            id: props.id,
            code: props.code,
            name: props.name,
            description: props.description,
            programName: props.programName,
            companyName: props.companyName,
            resellerId: props.resellerId,
            categoryId: props.categoryId
          }
        });
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      },

      getEffectiveDates: function(id){
        return $http({
          method: 'get',
          url: this.service + '/' + id + '/dates'
        });
      },

      getCouponsByCategory: function(categoryId, props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/category' + '/' + categoryId + q
        });
      },

      categories: {

        service: '',

        list: function(props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + "/" + id
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: {
              name: props.name,
              description: props.description
            }
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              name: props.name,
              description: props.description
            }
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service + '/' + id
          });
        }
      },

      effectiveDates: {

        service: '',

        list: function() {
          return $http({
            method: 'get',
            url: this.service
          });
        },

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + "/" + id
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: {
              couponId: props.couponId,
              effectiveStartDate: props.effectiveStartDate,
              effectiveEndDate: props.effectiveEndDate,
              notes: props.notes || ''
            }
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              couponId: props.couponId,
              effectiveStartDate: props.effectiveStartDate,
              effectiveEndDate: props.effectiveEndDate,
              notes: props.notes || ''
            }
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service + '/' + id
          });
        }
      },

      templates: {

        service: '',

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        update: function(props) {
          // Since all operations are post, put, or delete we are opting to use POST instead of PUT
          return $http({
            method: 'post',
            url: this.service + '/' + props.eventTemplateId,
            data: props.data
          });
        }

      }
    };

}]);